import { BomDataMergeInfo, InOrExclusionBean, MarketingRuleData } from "@org-avp/avp-avengers-partlist-service-api";

export enum EditPartlistMarketingDataDialogMode {
  SINGLE,
  MULTI,
}

export interface EditPartlistMarketingDataDialogDataEntry {
  partlistEntryId: string;
  materialNumber: string;
  originalRule?: string;
  marketingRuleData: MarketingRuleData[];
  filterClass: string[];

  // needed to show differences in timeframes or rules
  exclusion?: InOrExclusionBean;
  inclusion?: InOrExclusionBean;
  mergeInfo?: BomDataMergeInfo;
}

export interface EditPartlistMarketingDataDialogData {
  dialogMode: EditPartlistMarketingDataDialogMode;
  dialogDataEntries: EditPartlistMarketingDataDialogDataEntry[];
}
